if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.errorEl = this.querySelector('.cart-upsell__error');
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const button = event.target.closest('.cart-upsell__swatch');
        if (!button || button.disabled || button.classList.contains('is-loading')) return;
        event.preventDefault();
        this.addVariant(button);
      }

      async addVariant(button) {
        const variantId = button.dataset.variantId;
        const colorName = button.dataset.colorName;
        if (!variantId) return;

        this.clearError();
        button.classList.add('is-loading');
        button.classList.remove('is-just-added');

        const cartDrawer = document.querySelector('cart-drawer');
        // cart-drawer.getSectionsToRender() returns [{id, selector}] where id == section name.
        const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
          ? cartDrawer.getSectionsToRender()
          : [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
        const sectionNames = sectionsToRender.map((s) => s.id);

        const body = JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: sectionNames,
          sections_url: window.location.pathname,
        });

        try {
          const response = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body,
          });

          const data = await response.json();

          if (!response.ok || data.status) {
            const message = data.description || data.message || 'Could not add this color. Please try again.';
            throw new Error(message);
          }

          // Show "Added!" feedback briefly before the section re-renders.
          button.classList.remove('is-loading');
          button.classList.add('is-just-added');
          this.announce(`${colorName} StickyGrippy added`);

          // Hold the bounce/checkmark feedback long enough for the user to see it
          // before the section re-render replaces the swatch DOM.
          await new Promise((resolve) => setTimeout(resolve, 650));

          if (data.sections && cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else if (data.sections) {
            this.replaceSections(data.sections, sectionsToRender);
          }

          // Notify other subscribers (header cart bubble, etc.).
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-upsell',
              productVariantId: variantId,
              cartData: data,
            });
          }
        } catch (error) {
          button.classList.remove('is-loading');
          this.showError(error.message || 'Could not add this color. Please try again.');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'cart-drawer-upsell',
              productVariantId: variantId,
              errors: error.message,
              message: error.message,
            });
          }
        }
      }

      replaceSections(sections, sectionsToRender) {
        sectionsToRender.forEach((section) => {
          const html = sections[section.id];
          if (!html) return;
          const targetId = section.selector ? section.selector.replace(/^#/, '') : section.id;
          const target = document.getElementById(targetId);
          if (!target) return;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('.shopify-section') || doc.querySelector(section.selector || '.shopify-section');
          if (newContent) {
            target.innerHTML = newContent.innerHTML;
          }
        });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
        clearTimeout(this._errorTimer);
        this._errorTimer = setTimeout(() => this.clearError(), 4000);
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
      }

      announce(message) {
        const liveRegion = document.getElementById('CartDrawer-LiveRegionText');
        if (liveRegion) {
          liveRegion.textContent = message;
        }
      }
    }
  );
}
